import Rib from '@/generated/classes/Rib';
export default class RibExtend extends Rib {
  constructor() {
    super();
  }
}
